import type { ApiQuestion } from '../../../../internalTypes';
import { mapAnswerLogic } from '../shared/mapAnswerLogic';

export function buildRankOrderOptions(
  question: ApiQuestion,
  language?: string
): {
  id: string;
  optionLabel: string;
  imageUrl?: string;
  previewImageUrl?: string;
  answerLogic?: ReturnType<typeof mapAnswerLogic>;
}[] {
  return (question.answerDetails ?? [])
    .filter(answer => !answer.hidden && !answer.additional?.isHintText)
    .map((answer, index) => {
      const answerLogic = mapAnswerLogic(answer.controlConfig?.displayLogic);
      const asset = answer.answerAsset;
      const imageUrl = asset?.source || asset?.previewImageUrl;
      const previewImageUrl = asset?.previewImageUrl || asset?.source;

      return {
        id: answer.id ?? String(index),
        optionLabel:
          (language && answer.translations?.[language]?.answerText) || answer.answerText || '',
        ...(imageUrl ? { imageUrl } : {}),
        ...(previewImageUrl ? { previewImageUrl } : {}),
        ...(answerLogic ? { answerLogic } : {}),
      };
    });
}
